/**
 * @generated SignedSource<<fd7115ab8570c087ce45d9b4b0272cea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuizSubmissionEditorContentUsageFragment$data = {
  readonly content: {
    readonly name: string | null;
  };
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionFormContentUsageFragment">;
  readonly " $fragmentType": "QuizSubmissionEditorContentUsageFragment";
};
export type QuizSubmissionEditorContentUsageFragment$key = {
  readonly " $data"?: QuizSubmissionEditorContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionEditorContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuizSubmissionEditorContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuizSubmissionFormContentUsageFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "a8d5cb38271fbb932302eed151528650";

export default node;
